import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";

export const APPOINTMENT_ROUTES: Routes = [
  {
    path: "appointment",
    loadComponent: () => import("./appointment.component").then(m => m.AppointmentComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.appointment" },
    children: [
      {
        path: "",
        loadComponent: () => import("./appointment-info/appointment-info.component").then(m => m.AppointmentInfoComponent),
        data: { title: "pageTitles.appointment" },
      },
      {
        path: "visit/review",
        loadComponent: () => import("./appointment-review/appointment-review.component").then(m => m.AppointmentReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.visitReview" },
      },
      {
        path: "examination/review",
        loadComponent: () => import("./appointment-review/appointment-review.component").then(m => m.AppointmentReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.examinationReview" },
      },
      {
        path: "procedure/review",
        loadComponent: () => import("./appointment-review/appointment-review.component").then(m => m.AppointmentReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.procedureReview" },
      },
      {
        path: "vaccination/review",
        loadComponent: () => import("./appointment-review/appointment-review.component").then(m => m.AppointmentReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.vaccinationReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.appointmentMessages" },
      },
      {
        path: "visit/submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
      {
        path: "examination/submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
      {
        path: "procedure/submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
      {
        path: "vaccination/submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
